import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "./getCroppedImg";

const ImageCropper = ({ image, onCropComplete, onClose, id }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropChange = (crop) => setCrop(crop);
    const onZoomChange = (zoom) => setZoom(zoom);

    const onCropCompleteInternal = useCallback((_, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const handleCrop = async () => {
        const croppedImage = await getCroppedImg(image, croppedAreaPixels, id);
        onCropComplete(croppedImage);
    };

    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999
        }}>
            <div style={{
                background: "white",
                padding: "20px",
                borderRadius: "8px",
                width: "50%",
                textAlign: "center",
            }}>
                <div style={{ position: "relative", width: "100%", height: "500px" }}>
                    <Cropper
                        image={image}
                        crop={crop}
                        zoom={zoom}
                        aspect={1} // Change aspect ratio if needed
                        onCropChange={onCropChange}
                        onZoomChange={onZoomChange}
                        onCropComplete={onCropCompleteInternal}
                    />
                </div>
                <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between" }}>
                    <button onClick={onClose} className="bttn-close">Cancel</button>
                    <button onClick={handleCrop} className="bttn-upload">Crop & Save</button>
                </div>
            </div>
        </div>
    );
};

export default ImageCropper;
